import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function DialogPd({children, main_message, message, ok, cancel, okFn, cancelFn, style}) {
    const [open, setOpen] = React.useState(true);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <div>
                {children}
            </div>
            <Dialog
                style={style}
                open={open}
                PaperProps={{
                    style: {
                        maxWidth: '90vw', // например, не более 90% экрана
                    }
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {main_message}
                </DialogTitle>
                { message ?
                <DialogContent>
                        {message}
                </DialogContent>
                :''}
                <DialogActions>
                    <Button onClick={()=>{ handleClose(); okFn();} } autoFocus>
                        {ok}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
